import { useContext } from "react";

import { useTranslation } from "react-i18next";

import DateTime from "components/DateTime";
import CardItemValue from "components/TableDetails/components/CardItemValue";
import TableContext from "context/table/tableContext";

const OtherInfo = () => {
    const { detailsData } = useContext(TableContext);

    const { t } = useTranslation();

    const { created_by, created_at, updated_by, updated_at, last_checked_at } =
        detailsData;

    return (
        <div>
            <div>{t("Table##other information")}</div>

            <div>
                {created_by !== null && (
                    <>
                        <span>{t("Table##created by")}:</span>
                        <CardItemValue value={created_by.email} />
                    </>
                )}

                <span>{t("Table##created at")}:</span>

                <span>
                    <DateTime date={created_at} />
                </span>

                {updated_by !== null && (
                    <>
                        <span>{t("Table##updated by")}:</span>
                        <CardItemValue value={updated_by.email} />
                    </>
                )}

                {updated_at !== null && (
                    <>
                        <span>{t("Table##updated at")}:</span>

                        <span>
                            <DateTime date={updated_at} />
                        </span>
                    </>
                )}

                {last_checked_at !== null && (
                    <>
                        <span>{t("Table##last checked at")}:</span>

                        <span>
                            <DateTime date={last_checked_at} />
                        </span>
                    </>
                )}
            </div>
        </div>
    );
};

export default OtherInfo;
